/*jslint sloppy: true*/
/*global getResponsiveBreakpoint: true, isElementInViewport: true, jQuery: true */

var Northstar = Northstar || {};

(function ($, window, document) {
    'use strict';

    // Define Northstar gallery app
    Northstar.gallery = {
        opt: {
            items: {
                slidesToShow: 3,
                infinite: true,
                slide: '.item',
                responsive: [
                    {
                        breakpoint: 929,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 575,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            },
            simple: {
                slide: '.slide',
                lazyLoad: 'anticipated',
                fade: false
            },
            caption: {
                slide: '.caption',
                arrows: false
            },
            default: {
                slide: '.photo-gallery--item',
                appendArrows: $('.photo-gallery--arrows > div'),
                lazyLoad: 'anticipated',
                fade: false
            },
            center: {
                slide: '.photo-gallery--item',
                appendArrows: $('.photo-gallery--arrows > div'),
                centerMode: true,
                centerPadding: '0',
                variableWidth: true,
                lazyLoad: 'anticipated',
                fade: false
            },
            multiple: {
                slide: '.photo-gallery--item',
                centerMode: true,
                centerPadding: '0',
                variableWidth: false,
                lazyLoad: 'anticipated',
                fade: false,
                arrows: true

            }
        },

        attach: function () {
            //console.log('Northstar gallery.js loaded');

            // Initialize item sliders
            $('.slider-simple--items').slick(Northstar.gallery.opt.items);

            if ($('.photo-gallery--captions').length > 0)
            {
                Northstar.gallery.opt.multiple.asNavFor = '.photo-gallery--captions';
            }
            // Initialize simple sliders (photos & arrows)
            Northstar.gallery.create($('.slider-simple'), Northstar.gallery.opt.simple);

            // Initialize multiple sliders
            $('.photo-gallery--items.hero-carousel').slick(Northstar.gallery.opt.multiple);
            $('.photo-gallery--items.module-carousel').slick(Northstar.gallery.opt.multiple);

            // Photo Galleries (photos, captions, counts & arrows, center mode)      
            $('.photo-gallery:not(.hero-carousel)').each(function () {
                var opts, optscap;

                // Updating slide counter inside caption slider
                if ($('.photo-gallery--counter', this).length) {
                    $('.photo-gallery--captions', this).on('init', Northstar.gallery.updateCount);
                    $(this).on('beforeChange', Northstar.gallery.updateCount);
                }

                // Class for no captions
                if (!$('.caption', this).length) {
                    $(this).addClass('no-captions');
                }

                if ($('.vid360c', this).length) {
                    $(this).on('beforeChange', function (event, slick, currentSlide, nextSlide) {

                        eval('try{viewer' + (currentSlide + 1) + '.stopAutorotate();}catch{}');
                        eval('try{viewer' + (nextSlide + 1) + '.startAutorotate();}catch{}')


                    });
                }

                // Load options per size
                if ($(this).hasClass('photo-gallery--sm')) {
                    opts = Northstar.gallery.opt.center;
                    opts.responsive = [
                        {
                            breakpoint: 615, // match css
                            settings: {
                                variableWidth: false
                            }
                        }
                    ];
                }
                else if ($(this).hasClass('photo-gallery--md')) {
                    opts = Northstar.gallery.opt.center;
                    opts.responsive = [
                        {
                            breakpoint: 965, // match css
                            settings: {
                                variableWidth: false
                            }
                        }
                    ];
                }
                else if ($(this).hasClass('photo-gallery--lg')) {
                    opts = Northstar.gallery.opt.center;
                    opts.responsive = [
                        {
                            breakpoint: 1155, // match css
                            settings: {
                                variableWidth: false
                            }
                        }
                    ];


                    //temp for 360vids when load via api- need to address this
                    if ($('.vid360c', this).length) {
                        opts.draggable = false;
                        opts.swipe = false;
                        opts.swipeToSlide = false;
                        opts.touchMove = false;
                        opts.draggable = false
                        opts.accessibility = false;
                    }

                }
                else {
                    opts = Northstar.gallery.opt.default;
                }

                // Caption gallery if captions or count exist
                opts.asNavFor = $('.photo-gallery--captions', this);
                if (!$('.photo-gallery--captions', this).text().trim() == '') {
                    $(this).addClass('captions-enabled');
                    optscap = Northstar.gallery.opt.caption;
                    optscap.asNavFor = $('.photo-gallery--items', this);
                    Northstar.gallery.create($('.photo-gallery--captions', this), optscap);
                }
                else {
                    $('.photo-gallery--captions', this).remove();
                    opts.asNavFor = '';
                }

                // Create gallery
                Northstar.gallery.create($('.photo-gallery--items', this), opts);

            });
        },

        updateCount: function (event, slick, currentSlide, nextSlide) {

            var captions = $(slick.$slider).parent();
            if (typeof nextSlide == 'undefined') {
                var nextSlide = 0;
            }

            $('.photo-gallery--counter .current', captions).text(nextSlide + 1);
            $('.photo-gallery--counter .total', captions).text(slick.slideCount);
        },

        create: function (el, opts) {

            el.on('lazyLoaded', Northstar.gallery.lazyloaded);
            el.on('destroy', Northstar.gallery.destroy);

            el.slick(opts);
        },

        destroy: function (e, slick) {
            $('.bgloaded img', slick.$slider).each(function () {
                $(this)
                    .attr('data-lazy', $(this).attr('src'))
                    .removeAttr('src style')
                    .removeClass('slick-loading');
                $(this).parent().removeClass('bgloaded');
            });
        },

        lazyloaded: function (e, slick, image, imageSource) {

            image.attr('data-lazy', image.attr('src'));
            image.parent().addClass('bgloaded').css('background-image', 'url("' + imageSource + '")');


        }
    };

    // Initialize our app on document ready
    $(document).ready(function () {
        Northstar.gallery.attach();
        if ($('.vid360c', this).length) { create360viewers(); }
    });

}(jQuery, this, this.document));



